/**
 * Copyright 2017 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages/PaidFeatures_messages';

import Box from '../../components/Box';

const propTypes = {
  children: PropTypes.any,
};

const PaidFeatures = ({ children }) => (
  <Box headerLabel={<FormattedMessage {...messages.header} />}>
    {children}
  </Box>
);

PaidFeatures.propTypes = propTypes;

export default PaidFeatures;
